import * as tslib_1 from "tslib";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue/dist/index";
import { Component } from "vue-property-decorator";
import { toolbarConfig, editorConfig } from './wangeditorConfig';
import { DataSelectTextInputControl } from "@cloudpivot/form/src/common/controls/input-controls/data-select-text-input-control";
let RichText = class RichText extends DataSelectTextInputControl {
    constructor() {
        super(...arguments);
        this.editor = null;
        this.content = '';
        this.contentHtml = '';
        this.mode = 'default';
        this.lang = localStorage.getItem('locale');
        this.msg = this.lang == 'en' ? 'Please Input' : '请输入内容...';
        this.toolbarConfig = toolbarConfig; // 工具栏配置
        this.editorConfig = Object.assign({}, editorConfig(), { placeholder: this.msg });
        this.readOnlyEditorConfig = { readOnly: true, scroll: false }; // 编辑器配置
        this.test = '';
    }
    onCreated(editor) {
        this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
        // this.lang = localStorage.getItem('locale');
        // i18nChangeLanguage(this.lang)
    }
    created() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.contentHtml = this.val;
        });
    }
    mounted() {
        console.log('富文本初始化');
    }
    onChange(editor) {
        // 获取纯文本
        this.content = this.editor.getText() ? this.editor.getText() : null;
        // // 获取带样式内容html
        this.contentHtml = this.editor.getHtml();
        // console.log('onChange',this.contentHtml)
        this.setValue(this.contentHtml);
        // this.setTextVal(this.content); // 
    }
    beforeDestroy() {
        const editor = this.editor;
        if (editor == null)
            return;
        editor.destroy(); // 组件销毁时，及时销毁编辑器
    }
};
RichText = tslib_1.__decorate([
    Component({
        name: "customRichText",
        components: {
            Editor, Toolbar
        }
    })
], RichText);
export default RichText;
